import React from 'react'
import get from 'lodash.get'
import NavHeader from '../NavHeader'
import HeaderDialog from '../HeaderDialog'
import usePartner from '../../hooks/usePartner'
import PromoHeader from '../PromoHeader'
import useHasDisplayPromo from '../../hooks/useHasDisplayPromo'

function SmallHeader() {
  const shouldDisplayPromo = (promo) => {
    if (promo.promoNames) {
      // Should only show this promo if the associated promotions qualify (are "live")
      return useHasDisplayPromo(promo.promoNames)
    }

    return true
  }

  const getPromoToDisplay = (promoConfig) => {
    if (promoConfig) {
      const primaryPromo = promoConfig.primary
      const secondaryPromo = promoConfig.secondary

      if (primaryPromo && shouldDisplayPromo(primaryPromo)) {
        return primaryPromo
      }

      if (secondaryPromo && shouldDisplayPromo(secondaryPromo)) {
        return secondaryPromo
      }
    }

    return null
  }

  const [isOpen, setIsOpen] = React.useState(false)

  const headerConfig = usePartner('config.header', {})
  const appName = usePartner('appName', '')

  const promoConfig = get(headerConfig, 'promo')
  const promoToDisplay = getPromoToDisplay(promoConfig)
  const showPromoBanner =
    promoToDisplay && promoToDisplay.acceptedApps && promoToDisplay.acceptedApps.includes(appName)

  const { small, ...common } = headerConfig

  const logoPath = get(common, 'logoPath')
  const secondaryLogoPath = get(common, 'secondaryLogoPath')
  const secondaryLogoPadding = get(common, 'secondaryLogoPadding', 0)
  const linksOpenNewTab = get(headerConfig, 'linksOpenNewTab', true)

  const linkTarget = linksOpenNewTab ? '_blank' : undefined

  const navigation = get(headerConfig, 'navigation', [])
  const hasNavigation = navigation.length > 0

  const phoneNumber = get(headerConfig, 'phoneNumber')

  return (
    <React.Fragment>
      {showPromoBanner && <PromoHeader {...promoToDisplay} />}
      <NavHeader
        {...small}
        {...common}
        isOpen={false}
        logoPath={logoPath}
        secondaryLogoPath={secondaryLogoPath}
        phoneNumber={phoneNumber}
        target={linkTarget}
        onClick={() => setIsOpen(true)}
        hasNavigation={hasNavigation}
        rightPadding={secondaryLogoPadding}
      />
      <HeaderDialog
        {...small}
        {...common}
        isOpen={isOpen}
        logoPath={logoPath}
        secondaryLogoPath={secondaryLogoPath}
        target={linkTarget}
        onClose={() => setIsOpen(false)}
        hasNavigation={hasNavigation}
        rightPadding={secondaryLogoPadding}
      />
    </React.Fragment>
  )
}

SmallHeader.displayName = 'SmallHeader'

export default SmallHeader
